import axios from 'axios';

// Dify API 配置
const DIFY_API_URL = 'https://dify.arkdoo.com.cn/v1/chat-messages';
// 请替换为您的实际API密钥
// 实际
const DIFY_API_KEY = 'app-GQw5CP18WVolhjXiuPZQimem'; 
// 测试 
// const DIFY_API_KEY = 'app-PcYnt3baGX415BmM5LZixPMi';

const isDev = process.env.NODE_ENV === 'development';
const defaultBaseURL = isDev ? 'http://localhost:3001/api' : '/api';

const request = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || defaultBaseURL,
  timeout: 10000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 在这里可以添加token等认证信息
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Dify API 请求方法
export const sendMessageToDify = async (content, userId = `test`, conversationId = '') => {
  try {
    const requestData = {
      inputs: {},
      query: content,
      response_mode: "blocking",
      conversation_id: conversationId,
      user: userId,
      files: []
    };

    const response = await axios.post(
      DIFY_API_URL,
      requestData,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${DIFY_API_KEY}`
        }
      }
    );

    try {
      const answer = response.data?.answer;
      console.groupCollapsed('[Dify][answer]');
      console.log('query:', content);
      console.log('conversation_id(sent):', conversationId);
      console.log('conversation_id(returned):', response.data?.conversation_id);
      console.log('answer:', answer);
      console.groupEnd();
    } catch (e) {
      console.log('AI 返回的聊天文本:', response.data?.answer);
    }
    return response.data;
  } catch (error) {
    console.error('发送消息到 Dify 失败:', error);
    throw error;
  }
};

// ==================== 工艺管理 API ====================

// 检查是否使用Mock API
// 设置为 false 以使用真实数据库，设置为 true 使用Mock数据
const useMockAPI = process.env.NODE_ENV === 'development' && window.mockAPI && false;

// 获取所有审核项目
export const getAuditItems = async () => {
  try {
    if (useMockAPI) {
      return await window.mockAPI.getAuditItems();
    }
    const response = await request.get('/audit/items');
    return response;
  } catch (error) {
    console.error('获取审核项目失败:', error);
    throw error;
  }
};

// 添加新工艺到审核列表
export const addProcessToAudit = async (processData) => {
  try {
    if (useMockAPI) {
      return await window.mockAPI.addProcessToAudit(processData);
    }
    const response = await request.post('/audit/process', processData);
    return response;
  } catch (error) {
    console.error('添加工艺到审核列表失败:', error);
    throw error;
  }
};

// 审核工艺（批准/拒绝）
export const auditProcess = async (id, action, reason = '') => {
  try {
    if (useMockAPI) {
      return await window.mockAPI.auditProcess(id, action, reason);
    }
    const response = await request.put(`/audit/process/${id}`, {
      action,
      reason,
      approver: '当前审核员',
      approveTime: new Date().toISOString()
    });
    return response;
  } catch (error) {
    console.error('审核工艺失败:', error);
    throw error;
  }
};

// ==================== 反馈管理 API ====================

// 添加问卷反馈
export const addFeedback = async (feedbackData) => {
  try {
    if (useMockAPI) {
      return await window.mockAPI.addFeedback(feedbackData);
    }
    const response = await request.post('/feedback', {
      ...feedbackData,
      submitTime: new Date().toISOString(),
      status: 'pending'
    });
    return response;
  } catch (error) {
    console.error('添加反馈失败:', error);
    throw error;
  }
};

// 获取所有反馈
export const getFeedbacks = async () => {
  try {
    if (useMockAPI) {
      return await window.mockAPI.getFeedbacks();
    }
    const response = await request.get('/feedback');
    return response;
  } catch (error) {
    console.error('获取反馈失败:', error);
    throw error;
  }
};

// 审核反馈
export const auditFeedback = async (id, action, reason = '') => {
  try {
    const response = await request.put(`/feedback/${id}`, {
      action,
      reason,
      approver: '当前审核员',
      approveTime: new Date().toISOString()
    });
    return response;
  } catch (error) {
    console.error('审核反馈失败:', error);
    throw error;
  }
};

// ==================== 通知管理 API ====================

// 获取所有通知
export const getNotifications = async (userId = 'default_user') => {
  try {
    const response = await request.get(`/notifications?userId=${userId}`);
    return response;
  } catch (error) {
    console.error('获取通知失败:', error);
    throw error;
  }
};

// ==================== 问卷历史记录 API ====================

// 保存问卷提交记录
export const saveQuestionnaireSubmission = async (submissionData) => {
  try {
    const response = await request.post('/questionnaire/submit', submissionData);
    return response;
  } catch (error) {
    console.error('保存问卷提交记录失败:', error);
    throw error;
  }
};

// 获取用户的问卷提交历史
export const getQuestionnaireHistory = async (userId = 'default_user') => {
  try {
    const response = await request.get(`/questionnaire/history?userId=${userId}`);
    return response;
  } catch (error) {
    console.error('获取问卷历史失败:', error);
    throw error;
  }
};

// 获取单个问卷提交详情
export const getQuestionnaireSubmission = async (id) => {
  try {
    const response = await request.get(`/questionnaire/submission/${id}`);
    return response;
  } catch (error) {
    console.error('获取问卷提交详情失败:', error);
    throw error;
  }
};

// 删除问卷提交记录
export const deleteQuestionnaireSubmission = async (id) => {
  try {
    const response = await request.delete(`/questionnaire/submission/${id}`);
    return response;
  } catch (error) {
    console.error('删除问卷提交记录失败:', error);
    throw error;
  }
};

// 添加通知
export const addNotification = async (type, title, message = '', userId = 'default_user') => {
  try {
    const response = await request.post('/notifications', {
      type,
      title,
      message,
      userId
    });
    return response;
  } catch (error) {
    console.error('添加通知失败:', error);
    throw error;
  }
};

// 标记通知为已读
export const markNotificationAsRead = async (id, userId = 'default_user') => {
  try {
    const response = await request.put(`/notifications/${id}/read`, { userId });
    return response;
  } catch (error) {
    console.error('标记通知已读失败:', error);
    throw error;
  }
};

// 批量标记所有通知为已读
export const markAllNotificationsAsRead = async (userId = 'default_user') => {
  try {
    const response = await request.put('/notifications/read-all', { userId });
    return response;
  } catch (error) {
    console.error('批量标记通知已读失败:', error);
    throw error;
  }
};

// 删除通知
export const deleteNotification = async (id, userId = 'default_user') => {
  try {
    const response = await request.delete(`/notifications/${id}?userId=${userId}`);
    return response;
  } catch (error) {
    console.error('删除通知失败:', error);
    throw error;
  }
};

// 清空所有通知
export const clearAllNotifications = async (userId = 'default_user') => {
  try {
    const response = await request.delete(`/notifications?userId=${userId}`);
    return response;
  } catch (error) {
    console.error('清空通知失败:', error);
    throw error;
  }
};

export default request;